'Use Client';
import React, { memo, useEffect, useMemo, useState } from 'react';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
const InfiniteScroll = dynamic(() => import('react-infinite-scroll-component'));

import { formatDate } from '@/utils/dateHelper';
import { useLoading, useRequest } from '@/components/App';
import { ADS_DATA, QUERY_DATA, REQUEST } from '@/types/interfaces';

const HomeBlogPage = dynamic(() => import('../Home/Components/HomeBlogPage'));

const AdsItem = dynamic(() => import('./Components/AdsItem'));
const TopCity = dynamic(() => import('./Components/TopCity'));
const Description = dynamic(() => import('./Components/Description'));
const SimilarCity = dynamic(() => import('./Components/SimilarCity'));
const BannerAds = dynamic(() => import('./Components/BannerAds'));
const BreadCrumb = dynamic(() => import('./Components/BreadCrumb'));

const categoryData = ['escorts'];

function Index(props: any) {
  const router = useRouter();
  const { loading, request } = useRequest();
  const [page, setPage] = useState(1);
  const [data, setData]: any = useState(props.listData || []);
  const [hasMore, setHasMore] = useState(true);

  const { ButtonLoader } = useLoading();

  const queryData: QUERY_DATA = useMemo(() => {
    if (router.query && router.query.city) {
      return { category: 'escorts', state: router.query.city };
    }
    if (router.query && router.query.params) {
      const { params } = router.query;
      const [category, state]: any = params;
      if (categoryData.includes(category)) {
        return { category, state };
      } else {
        router.push('/404');
        return {};
      }
    }
    return {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router.query.params]);

  const fetchMoreData = async () => {
    const nextPage = page + 1;
    const req: any = (await request('GET_SEARCH', {
      limit: 5,
      page: nextPage,
      ...queryData,
    })) as REQUEST;

    if (req?.status) {
      const newData = req?.data?.result ?? [];
      if (newData.length > 0) {
        setData((prevData: any) => [...prevData, ...newData]);
        setPage(nextPage);
      } else {
        setHasMore(false); // No more data to load
      }
    }
  };

  const refreshFunction = async () => {
    setPage(1);
    setHasMore(true);
    const req: any = (await request('GET_SEARCH', {
      limit: 10,
      page: 1,
      ...queryData,
    })) as REQUEST;

    if (req?.status) {
      setData(req?.data?.result ?? []);
    }
  };

  const children = useMemo(() => {
    return (
      <>
        {data?.map((ads: ADS_DATA, index: number) => (
          <div key={index} className={ads.ads_images.length !== 0 ? 'ads-listing' : 'ads-img-listing ads-listing'}>
            <AdsItem ads={ads} />
          </div>
        ))}
      </>
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, ButtonLoader, loading]);

  const isLoading = useMemo(() => loading?.GET_SEARCH_LOADING, [loading]);

  useEffect(() => {
    setData(props.listData);
  }, [props.listData]);
  return (
    <>
      <section className="breadcrum-sec">
        <div className="container">
          <BreadCrumb queryData={queryData} />
          <div className="ads-inner-title-cls">
            <h2 className="cat_title">
              {props.descriptionData.h1Tag ||
                'List of Verified Call Girls in India with Photos. Choose city and search for Escort Service'}
            </h2>
            <p>{props.descriptionData.small_description}</p>
          </div>
        </div>
      </section>
      <section className="ads-sec" id="adSection">
        <div className="container">
          <p>Last Updated on: {formatDate(new Date(), 'DD-MM-YYYY hh:mm:ss a')}</p>
          <InfiniteScroll
            dataLength={data.length} // This is important field to render the next data
            next={fetchMoreData}
            hasMore={hasMore} // Update based on availability of more data
            loader={isLoading ? ButtonLoader({ color: '#101828' }) : null}
            refreshFunction={refreshFunction} // Add the refresh function here
            pullDownToRefresh
            pullDownToRefreshThreshold={10}
          >
            {children}
          </InfiniteScroll>
        </div>
        <TopCity queryData={queryData} />
        <Description descriptionData={props.descriptionData} />
        <BannerAds />
        <HomeBlogPage blogsData={props.descriptionData.latestBlogs} />
        <SimilarCity areaData={props.descriptionData} queryData={queryData} />
      </section>
    </>
  );
}

export default memo(Index);
